interface SystemDiagramSectionProps {
  titleLine1: string
  titleLine2: string
  bodyLine1: string
  bodyLine2: string
  emphasisLine1: string
  emphasisLine2: string
  ctaLabel: string
  onCtaClick?: () => void
  imageUrl: string
  imageUrlMobile: string
  imageAlt: string
}

export function SystemDiagramSection({
  titleLine1,
  titleLine2,
  bodyLine1,
  bodyLine2,
  emphasisLine1,
  emphasisLine2,
  ctaLabel,
  onCtaClick,
  imageUrl,
  imageUrlMobile,
  imageAlt,
}: SystemDiagramSectionProps) {
  return (
    <section id="system-diagram" data-marketing-section="" className="w-full bg-qb-bg py-14 lg:py-26 tracking-[-0.6px]">
      <div className="mx-auto max-w-[1136px] px-6 lg:px-0 flex flex-col lg:flex-row gap-10 lg:gap-0 items-center lg:justify-between">
        {/* Text block — Figma mobile (node 150:16927) centers all text + CTA; desktop reverts to left */}
        <div className="flex flex-col gap-6 lg:gap-10 items-center text-center lg:items-start lg:text-left">
          <div className="flex flex-col gap-2.5 lg:gap-1 font-bold text-[28px] lg:text-[40px] leading-[1.4] lg:leading-[1.2]">
            <p className="text-qb-text-high whitespace-pre-line lg:whitespace-nowrap">
              {titleLine1}
            </p>
            <p className="text-qb-primary whitespace-pre-line lg:whitespace-nowrap">
              {titleLine2}
            </p>
          </div>
          <div className="flex flex-col gap-6">
            <div className="text-qb-text-mid font-normal text-[18px] lg:text-[20px] leading-[1.5]">
              <p>{bodyLine1}</p>
              <p>{bodyLine2}</p>
            </div>
            <div className="text-qb-text-high font-bold text-[20px] lg:text-[24px] leading-[1.5] lg:leading-[1.4]">
              <p>{emphasisLine1}</p>
              <p>{emphasisLine2}</p>
            </div>
          </div>
          <button
            type="button"
            onClick={onCtaClick}
            className="marketing-cta inline-flex items-center justify-center h-12 lg:h-14 px-6 rounded-full bg-qb-primary text-white font-medium lg:font-semibold text-[18px] lg:text-[20px] leading-[1.5] shadow-[0px_4px_4px_rgba(0,0,0,0.1)] hover:opacity-90 transition-opacity"
          >
            {ctaLabel}
          </button>
        </div>

        {/* Diagram image */}
        <picture>
          <source media="(min-width: 1024px)" srcSet={imageUrl} />
          <img
            src={imageUrlMobile}
            alt={imageAlt}
            className="w-[312px] h-[361px] lg:w-[670px] lg:h-[509px] object-contain"
          />
        </picture>
      </div>
    </section>
  )
}
